import { useEffect, useState } from "react";
import { Container,Row,Col } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';

import * as constantes from './../constants/Constants' 
import UseApiService from "./../services/Api.service";
import LocalStorageManager from "../services/LocalStorageManager.service";

import Principal from './partial/login/Principal'
import Login from "./partial/login/Login";
import Registrar from "./partial/login/Registrar";

export default function LoginSingle ({title,handleLogin}){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [recordar, setRecordar] = useState(false);

  const [regNombres,setRegNombres] = useState('');
  const [regApellidos,setRegApellidos] = useState('');
  const [regTelefonos,setRegTelefonos] = useState('');
  const [regCorreo,setRegCorreo] = useState('');
  const [regContraseña,setRegContraseña] = useState('');
  const [regTerminos,setRegTerminos] = useState('');
  const [regNewsletter,setRegNewsletter] = useState('');

  const [error,setError] = useState(false);
  const [viewState,setViewState] = useState('');    
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); 

  useEffect(()=>{
    //LocalStorageManager.clear();
  },[]);
  
  const handleChange = (view) => {
    setViewState(view);
  }

  const handleChangeInput = (e) =>{
    const { id, value, checked, type } = e.target;
    
    const setters = {
      email: setEmail,
      password: setPassword,
      recordar: setRecordar,
      regNombres: setRegNombres,
      regApellidos: setRegApellidos,
      regTel: setRegTelefonos,
      regEmail: setRegCorreo,
      regPassword: setRegContraseña,
      regTerminos: setRegTerminos,
      regNewsletter: setRegNewsletter,
    };

    if (setters[id]) {
      setters[id](type === 'checkbox' ? checked : value);
    }

    setError('');
  }

  const iniciarRegistro = () => {
    UseApiService(constantes.C_API_REGISTER, {
      method: 'POST',
      body:{ email: email, pass: password,recordar: recordar}      
    })
    .then(({ data, error }) => {
    if (error) {            
      LocalStorageManager.clear();      
      setError(true);
    } else {      
      if (data.sub) {        
        LocalStorageManager.setItem('s_islogged','true');
        LocalStorageManager.setItem('s_email',data.email);
        LocalStorageManager.setItem('s_name',data.given_name);
        LocalStorageManager.setItem('s_fname',data.family_name);
        LocalStorageManager.setItem('s_sid',data.sub);
        LocalStorageManager.setItem('s_token',data.access_token);
        setError(false);        
        //window.location.reload();
      }
      else{
        setError(true);        
      }
    }
    })
    .catch((e)=>{      
      setError(true);      
    })
    .finally((e)=>{
      setLoading(false);      
    });

  }

  const iniciarSesion = () => {
    UseApiService(constantes.C_API_LOGIN_URL, {
      method: 'POST',
      body:{ email: email, pass: password,recordar: recordar}      
    })
    .then(({ data, error }) => {
    if (error) {            
      LocalStorageManager.clear();      
      setError(true);
    } else {      
      if (data.sub) {        
        LocalStorageManager.setItem('s_islogged','true');
        LocalStorageManager.setItem('s_email',data.email);
        LocalStorageManager.setItem('s_name',data.given_name);
        LocalStorageManager.setItem('s_fname',data.family_name);
        LocalStorageManager.setItem('s_sid',data.sub);
        LocalStorageManager.setItem('s_token',data.access_token);

        LocalStorageManager.setItem('s_ppid',data.ppid);
        LocalStorageManager.setItem('s_term_description',data.term_description);
        LocalStorageManager.setItem('s_status',data.status);

        setError(false);
        handleLogin(false);
        setTimeout(() => {
          navigate('/');          
        }, 500);        
      }
      else{
        setError(true);
      }
    }
    })
    .catch((e)=>{
      setError(true);      
    })
    .finally((e)=>{
      setLoading(false);
    });
  }
  
  return (
    <Container fluid>      
      <Row>
        <Col className="welcome-login py-5">
          <Container className='login-principal'>
            <Row>
              <Col className="login-content">                
                <div 
                  className='login-titulo fs-2 text-center fw-semibold lh-sm'
                >
                  {title}
                </div>
                {/*
                <div className='login-descripcion px-4 text-center'>
                  Si ya eres <b>suscriptor</b> inicia sesión.
                </div>           
                */}
                <div className='principal-form'>
                  {viewState==="login"&&<Login 
                    handleChange={handleChange} 
                    iniciarSesion={iniciarSesion} 
                    handleChangeInput={handleChangeInput}
                    error={error}
                  />}
                  {viewState==="registrar"&&<Registrar 
                    handleChange={handleChange}
                    iniciarRegistro={iniciarRegistro}
                  />}
                  {viewState===""&&<Principal handleChange={handleChange}/>}
                </div>          
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}


